var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhoneIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.4312 28.875C28.8437 28.875 29.1875 28.7375 29.4625 28.4625C29.7375 28.1875 29.875 27.8438 29.875 27.4313V21.8625C29.875 21.5417 29.7719 21.2607 29.5656 21.0196C29.3594 20.7795 29.0958 20.625 28.775 20.5562L24.0312 19.5938C23.7104 19.5479 23.3836 19.5763 23.0509 19.679C22.719 19.7826 22.45 19.9375 22.2437 20.1437L19.0125 23.375C17.2708 22.3208 15.6781 21.0719 14.2344 19.6281C12.7906 18.1844 11.5875 16.6375 10.625 14.9875L13.925 11.6187C14.1312 11.4125 14.2632 11.1774 14.321 10.9134C14.3778 10.6503 14.3833 10.3583 14.3375 10.0375L13.4438 5.225C13.3979 4.90417 13.249 4.64062 12.9969 4.43437C12.7448 4.22812 12.4583 4.125 12.1375 4.125H6.56875C6.15625 4.125 5.8125 4.2625 5.5375 4.5375C5.2625 4.8125 5.125 5.15625 5.125 5.56875C5.125 8.525 5.78408 11.4065 7.10225 14.2134C8.4195 17.0211 10.1612 19.5076 12.3272 21.6728C14.4924 23.8388 16.9784 25.5805 19.7852 26.8978C22.593 28.2159 25.475 28.875 28.4312 28.875Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneIcon);
export default __webpack_public_path__ + "static/media/phone-icon.1815108726ff550335e792c871808011.svg";
export { ForwardRef as ReactComponent };